<template lang="pug">
div(style="min-height: 0;")
    Card.group-card
        p(slot="title")
            Icon(type="md-clipboard")
            |
            | Bulletin
        Row(:gutter="16")
            Input(v-model="$store.state.frontendConfigs.announcement[$store.state.userPref.lang]" type="textarea" :autosize="{minRows: 5,maxRows: 5}" disabled)
        Divider
        Row(type="flex" justify="center")
            a(v-if="$store.state.frontendConfigs.adminMail !==''" :href="'mailto:'+$store.state.frontendConfigs.adminMail") {{ $t("frontends.sendMailToAdmin") }}
            div(v-if="$store.state.frontendConfigs.adminMail !=='' && $store.state.frontendConfigs.userGuideUrl!=='' ")
                span &emsp;
                span |
                span &emsp;
            a(v-if="$store.state.frontendConfigs.userGuideUrl !==''" :href="$store.state.frontendConfigs.userGuideUrl" target="_blank")  {{ $t("frontends.userGuideText") }}
</template>
<script>
export default {
    name: "BulletinBoardCard",
    props: [],
    components: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {};
    },
    methods: {},
    mounted() {},
    computed: {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Home/BulletinBoardCard.vue